import Cookies from 'components/Common/Cookies'
import { lazy, Suspense } from 'react'
import { Right } from './_styles'
import { MainContainer, MainWrapper } from '../ForgotPassword/Common/_styles'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

const Left = lazy(() => import(/* webpackChunkName: "signup" */ './Left'))

const Signup = () => {
  const [cookiePolicy] = useLocalStorage('wwl-cookie_policy', 'false')

  return (
    <MainWrapper>
      {cookiePolicy !== 'true' && <Cookies />}
      <MainContainer>
        <Suspense fallback={null}>
          <Left />
        </Suspense>
        <Right />
      </MainContainer>
    </MainWrapper>
  )
}

export default Signup
